// extracted by mini-css-extract-plugin
export default {"toggleBtn":"ThemeToggle_toggleBtn__ELltG","dark":"ThemeToggle_dark__iGPyx","input":"ThemeToggle_input__GEUXk"};